import React from "react";

// import RichTextEditor from "./common/RichTextEditor";
// import QuestionContext from "../QuestionContext";
import AudioInputRecord from "./common/AudioInputRecord";
import Prompt from "./shared/Prompt";

interface Props {
  data: any;
}

const Audio: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <>
      <Prompt data={props.data.content.prompt} />
      <AudioInputRecord />
    </>
  );
};
export default Audio;
